/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { BaseAction } from '../../types/global.type';
import * as actions from '../../types/permissions.type';

export type PermissionsState = {
  data: any,
  error?: any,
  applications?: Array<any>,
  isSetting?: boolean,
};

const initialState: PermissionsState = {
  error: null,
  data: null,
  applications: [],
  isSetting: false,
}

export const permissionsReducer = (
  state: PermissionsState = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.GET_APPLICATION_PERMISSIONS:
      return {...state, isSetting: true, error: null}
    case actions.GET_APPLICATION_PERMISSIONS_SUCCESS:
      return {
        ...state,
        applications: action.payload,
        error: null,
        isSetting: false
      }
    case actions.GET_APPLICATION_PERMISSIONS_FAILURE:
      return {...state, error: action.payload, isSetting: false}
    case actions.UPDATE_CURRENT_PERMISSION:
      return {
        ...state,
        data: action.payload
      };
    default:
      return state;
  }
};
